export async function fetchCommentAreaDetail(area_id: number) {
  return http
    .get<CommentAreaInfo>('/v1/comment/area_info', { area_id })
    .then((res) => res.data)
}
